// Simple on-chain wallet balance fetcher (Ethereum, Polygon, BSC)
// Uses public APIs (Etherscan, Polygonscan, BscScan)

const API_KEYS = {
  ethereum: 'YourEtherscanApiKey',
  polygon: 'YourPolygonscanApiKey',
  bsc: 'YourBscscanApiKey',
};

const API_URLS = {
  ethereum: 'https://api.etherscan.io/api',
  polygon: 'https://api.polygonscan.com/api',
  bsc: 'https://api.bscscan.com/api',
};

// Native balance (ETH, MATIC, BNB) via backend
export async function fetchNativeBalance({ address, chain }) {
  const url = '/api/onchain/native-balance';
  try {
    console.log('[fetchNativeBalance] Backend Request:', { address, chain });
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ address, chain })
    });
    if (!res.ok) throw new Error('Erreur backend: ' + res.status);
    const data = await res.json();
    console.log('[fetchNativeBalance] Backend Response:', data);
    return data.balance;
  } catch (err) {
    console.error('[fetchNativeBalance] Backend Error:', err);
    throw err;
  }
}

// ERC-20/BEP-20 token balances
export async function fetchTokenBalances({ address, chain, tokens }) {
  // tokens: array of { contract, symbol, decimals }
  const results = [];
  for (const token of tokens) {
    const url = `${API_URLS[chain]}?module=account&action=tokenbalance&contractaddress=${token.contract}&address=${address}&tag=latest&apikey=${API_KEYS[chain]}`;
    const res = await fetch(url);
    const data = await res.json();
    if (data.status === '1') {
      results.push({
        symbol: token.symbol,
        balance: parseFloat(data.result) / Math.pow(10, token.decimals),
      });
    } else {
      results.push({ symbol: token.symbol, balance: 0 });
    }
  }
  return results;
}
